<template>
    <div class="wrapper">
        <side-bar>
            <template slot="links">
                <sidebar-link
                    v-if="showIfRoleIs('admin')"
                    :to="{ name: 'dashboard' }"
                    :name="$t('global.dashboard')"
                    icon="fas fa-chart-bar text-primary"
                />
                <sidebar-link
                    v-if="showIfRoleIs('admin,admin-rede,asf-admin,asf-frontdesk,asf-technician')"
                    :to="{ name: 'repairs' }"
                    :name="$t('global.repairs')"
                    icon="fas fa-print text-primary"
                />
                <sidebar-link
                    v-if="showIfRoleIs('admin')"
                    :to="{ name: 'request_parts' }"
                    :name= "$t('global.sendearlykit')"
                    icon="fas fa-cogs text-primary"
                />
                <sidebar-link
                    v-if="showIfRoleIs('asf-admin') && $isMainTenant()"
                    :to="{ name: 'request_parts' }"
                    :name= "$t('global.buy_parts')"
                    icon="fas fa-cogs text-primary"
                />
                <sidebar-link
                    v-if="showIfRoleIs('admin,asf-admin')"
                    :to="{ name: 'inventory' }"
                    :name="$t('global.inventory')"
                    icon="fas fa-archive text-primary"
                />
                <sidebar-link
                    v-if="showIfRoleIs('admin,asf-admin,asf-frontdesk,asf-technician')"
                    :to="{ name: 'requests' }"
                    :name="$t('global.requests')"
                    icon="fas fa-file-invoice text-primary"
                />
                <sidebar-link
                    v-if="showIfRoleIs('admin')"
                    :to="{ name: 'parts' }"
                    :name="$t('global.parts')"
                    icon="fas fa-cogs text-primary"
                />
                <sidebar-link
                    v-if="showIfRoleIs('admin')"
                    :to="{ name: 'models' }"
                    :name="$t('global.models')"
                    icon="fas fa-cog text-primary"
                />
                <sidebar-link
                    v-if="showIfRoleIs('admin,asf-admin,asf-frontdesk,asf-technician')"
                    :to="{ name: 'documents' }"
                    :name="$t('global.documents')"
                    icon="fas fa-copy text-primary"
                />
                <sidebar-link
                    v-if="showIfRoleIs('admin,admin-rede')"
                    :to="{ name: 'asfs' }"
                    :name="$t('global.asfs')"
                    icon="fas fa-wrench text-primary"
                />
                <sidebar-link
                    v-if="showIfRoleIs('admin')"
                    :to="{ name: 'assessments' }"
                    :name="$t('global.assessments')"
                    icon="fas fa-file-alt text-primary"
                />
                <sidebar-link
                    v-if="showIfRoleIs('admin,admin-rede,asf-admin')"
                    :to="{ name: 'users' }"
                    :name="$t('global.admin')"
                    icon="fas fa-user-cog text-primary"
                />
                <sidebar-link
                    v-if="showIfRoleIs('admin,admin-rede,asf-admin')"
                    :to="{ name: 'customers' }"
                    :name="$t('global.customers')"
                    icon="fas fa-user-cog text-primary"
                />
            </template>
        </side-bar>
        <div class="main-panel">
            <top-navbar></top-navbar>

            <dashboard-content @click.native="toggleSidebar"></dashboard-content>

            <content-footer></content-footer>
        </div>
    </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
export default {
   computed: {
    isAdmin() {
        return this.$store.getters["auth/getIsAdmin"];
    },
  },
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    showIfRoleIs(role) {
      return this.$store.getters["auth/isInRoles"](role);
    }
  }
};
</script>
